import { appliedReportDefaults } from './applied';
import { currentReportDefaults } from './current';

export default {
    applied: appliedReportDefaults,
    current: currentReportDefaults,
    reportCategory: '',
};
